import { OMPLIR_USUARI_AUTENTICAT } from "./actionTypes";
import { getIdObservadorIntroduccio } from "../reducers";
import { fetchObtenirDadesUsuariPerIdObservador } from "./consultesServidor";

export const omplirUsuariAutenticat = usuari => {
  return {
    type: OMPLIR_USUARI_AUTENTICAT,
    payload: usuari
  };
};

export const obtenirDadesUsuariPerIdObservador = () => {
  return (dispatch, getState) => {
    const state = getState();
    const idObservador = parseInt(getIdObservadorIntroduccio(state));

    if (!isNaN(idObservador)) {
      return dispatch({
        type: OMPLIR_USUARI_AUTENTICAT,
        promise: fetchObtenirDadesUsuariPerIdObservador(idObservador)
      });
    }
  };
};
